// Matches the .turbo-tooltip--drawer width set in application.css
const DRAWER_WIDTH = 320
const EDGE_GAP = 8

export function oppositeDirection(direction) {
  return { left: "right", right: "left", top: "bottom", bottom: "top" }[direction]
}

export function positionVars({ direction, rect, scroll, documentWidth, viewportWidth, boundaries = 0 }) {
  if (direction === "top") {
    return {
      top: `${scroll.y + rect.top - EDGE_GAP}px`,
      left: `${clampedLeft(rect, scroll, viewportWidth)}px`,
    }
  }

  if (["right", "left"].includes(direction)) {
    const opposite = oppositeDirection(direction)

    return {
      top: `${scroll.y + rect.top}px`,
      [opposite]: `${xPosition(rect, scroll, documentWidth, opposite, boundaries)}px`,
    }
  }

  return {}
}

function clampedLeft(rect, scroll, viewportWidth) {
  const centered = scroll.x + rect.left + rect.width / 2 - DRAWER_WIDTH / 2

  return Math.max(EDGE_GAP, Math.min(centered, scroll.x + viewportWidth - DRAWER_WIDTH - EDGE_GAP))
}

function xPosition(rect, scroll, documentWidth, side, boundaries) {
  if (side === "left") return scroll.x + rect.left + rect.width + boundaries

  return documentWidth - scroll.x - rect.left + boundaries
}
